import { render, staticRenderFns } from "./section_title.vue?vue&type=template&id=42080b56"
import script from "./section_title.vue?vue&type=script&lang=js"
export * from "./section_title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports